import { setDialogVisible } from "../../../actions/session";
import Icon from "../../../controls/Icon";
import Image from "../../../controls/Image";
import * as tooltip from "../../../controls/TooltipControls";
import { ComponentEx, connect, translate } from "../../../controls/ComponentEx";
import getVortexPath from "../../../util/getVortexPath";
import opn from "../../../util/opn";
import { truthy } from "../../../util/util";
import { clearOAuthCredentials, setUserAPIKey } from "../actions/account";
import { setUserInfo } from "../actions/persistent";
import { FALLBACK_AVATAR, NEXUS_BASE_URL } from "../constants";
import * as path from "path";
import * as React from "react";
import { pathToFileURL } from "url";
import { isLoggedIn } from "../selectors";
import { showError } from "../../../util/message";
const START_TIME = Date.now();
class LoginIcon extends ComponentEx {
    render() {
        const { t, networkConnected } = this.props;
        if (!networkConnected) {
            return (React.createElement("span", { id: "login-control" },
                React.createElement(tooltip.Icon, { name: "disconnected", tooltip: t("Network is offline") })));
        }
        return (React.createElement("span", { id: "login-control" },
            this.renderMembershipStatus(),
            this.renderLoginName(),
            this.renderAvatar()));
    }
    logOut = () => {
        const { onClearOAuthCredentials, onSetAPIKey, onClearUserInfo } = this.props;
        onSetAPIKey(undefined);
        onClearOAuthCredentials();
        onClearUserInfo();
    };
    getMembershipText(userInfo) {
        if (userInfo?.isPremium === true) {
            return "★ Premium";
        }
        else if (userInfo?.isSupporter === true &&
            userInfo?.isPremium === false) {
            return "Supporter";
        }
        else if (userInfo?.isLifetime === true) {
            return "Premium";
        }
        return "Free";
    }
    renderMembershipStatus = () => {
        const { t, userInfo } = this.props;
        const membership = this.getMembershipText(userInfo);
        const classes = `membership-status ${membership.toLocaleLowerCase()}`;
        if (this.isLoggedIn()) {
            return (React.createElement("div", { id: "membership-status", className: classes },
                React.createElement("div", { className: "membership-status-text" }, membership)));
        }
        else {
            return null;
        }
    };
    renderLoginName = () => {
        const { t, userInfo } = this.props;
        if (this.isLoggedIn()) {
            return (React.createElement("div", null,
                React.createElement("div", { className: "username" }, userInfo.name),
                React.createElement("div", { className: "logout-button" },
                    React.createElement("a", { onClick: this.logOut }, t("Log out")))));
        }
        else {
            return null;
        }
    };
    renderAvatar = () => {
        const { t, userInfo } = this.props;
        const loggedIn = this.isLoggedIn();
        const fallback = pathToFileURL(path.join(getVortexPath("assets"), "..", FALLBACK_AVATAR)).href;
        const profileIcon = truthy(userInfo?.profileUrl)
            ? `${userInfo.profileUrl}?r_${START_TIME}`
            : fallback;
        return (React.createElement(tooltip.Button, { id: "btn-login", tooltip: loggedIn ? t("Show Details") : t("Log in"), onClick: this.showLoginLayer }, loggedIn ? (React.createElement(Image, { srcs: [profileIcon, fallback], circle: true, style: { height: 32, width: 32 } })) : (React.createElement(Icon, { name: "user", className: "logout-avatar" }))));
    };
    showLoginLayer = async () => {
        const { userInfo } = this.props;
        if (!this.isLoggedIn()) {
            this.context.api.events.emit("analytics-track-click-event", "Profile", "Site profile");
            this.setDialogVisible(true);
            this.launchNexusOauth();
        }
        else {
            opn(`${NEXUS_BASE_URL}/users/${userInfo.userId}`).catch((err) => undefined);
        }
    };
    launchNexusOauth = () => {
        this.context.api.events.emit("request-nexus-login", (err) => {
            if (err !== null) {
                this.props.onShowError("Login Failed", err);
                this.hideLoginLayer();
            }
        });
    };
    isLoggedIn = () => {
        const { isLoggedIn, userInfo } = this.props;
        //return isLoggedIn;
        return isLoggedIn && userInfo !== undefined && userInfo !== null;
    };
    hideLoginLayer = () => {
        this.setDialogVisible(false);
    };
    setDialogVisible = (visible) => {
        this.props.onShowDialog();
    };
}
function mapStateToProps(state) {
    return {
        isLoggedIn: isLoggedIn(state),
        userInfo: state.persistent.nexus.userInfo,
        networkConnected: state.session.base.networkConnected,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSetAPIKey: (APIKey) => dispatch(setUserAPIKey(APIKey)),
        onClearOAuthCredentials: () => dispatch(clearOAuthCredentials(null)),
        onClearUserInfo: () => dispatch(setUserInfo(undefined)),
        onShowDialog: () => dispatch(setDialogVisible("login-dialog")),
        onShowError: (title, err) => showError(dispatch, title, err, { allowReport: false }),
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(LoginIcon));
